import { BranchModel, DepartmentModel, CollaboratorModel, IdeaModel } from "../../model/BrainstormModel";

export interface BrainstormState {
    loadingListBranches: boolean;
    errorListBranches: boolean;
    branchesData: Array<BranchModel>;
    loadingListDepartments: boolean;
    errorListDepartments: boolean;
    departmentsData: Array<DepartmentModel>;
    loadingListCollaborators: boolean;
    errorListCollaborators: boolean;
    collaboratorsData: Array<CollaboratorModel>;
    loadingGetCollaborator: boolean;
    errorGetCollaborator: boolean;
    collaboratorData: CollaboratorModel;
    loadingListImplementerIdeas: boolean;
    errorListImplementerIdeas: boolean;
    implementerIdeasData: Array<IdeaModel>;
    loadingListCollaboratorIdeas: boolean;
    errorListCollaboratorIdeas: boolean;
    collaboratorIdeasData: Array<IdeaModel>;
    loadingGetIdea: boolean;
    errorGetIdea: boolean;
    ideaData: IdeaModel;
    loadingSaveIdea: boolean;
    errorSaveIdea: boolean;
    savedIdeaData: IdeaModel;
}

export const initialState: BrainstormState = {
    loadingListBranches: false,
    errorListBranches: false,
    branchesData: [],
    loadingListDepartments: false,
    errorListDepartments: false,
    departmentsData: [],
    loadingListCollaborators: false,
    errorListCollaborators: false,
    collaboratorsData: [],
    loadingGetCollaborator: false,
    errorGetCollaborator: false,
    collaboratorData: null,
    loadingListImplementerIdeas: false,
    errorListImplementerIdeas: false,
    implementerIdeasData: [],
    loadingListCollaboratorIdeas: false,
    errorListCollaboratorIdeas: false,
    collaboratorIdeasData: [],
    loadingGetIdea: false,
    errorGetIdea: false,
    ideaData: null,
    loadingSaveIdea: false,
    errorSaveIdea: false,
    savedIdeaData: null
}


// WEBPACK FOOTER //
// ./src/store/state/BrainstormState.ts